import * as React from 'react';

// components
import { InputPassword as InputPasswordBase } from '@shopee-user/input';

// Utils
import { isFeatureEnabled } from '@shopee-user/business-customization-logic';

// Constants
import { Feature } from '@shopee-user/feature-toggle';

// types
import { InputPasswordProps } from '@shopee-user/input';

export const MAX_PASSWORD_LENGTH = isFeatureEnabled(
  Feature.LoginByPasswordRestrictPasswordLength
)
  ? 16
  : undefined;

function LoginInputPassword(props: InputPasswordProps) {
  return <InputPasswordBase maxLength={MAX_PASSWORD_LENGTH} {...props} />;
}

export default LoginInputPassword;
